import React from "react";
import "./recent_purchases.css";
import SectionName from "../section-name/section-name";
import icon1 from "./icons/icon1.png";
import icon2 from "./icons/icon2.png";
import icon3 from "./icons/icon3.png";
import icon4 from "./icons/icon4.png";
import p1 from '../../assets/images/properties/p1.png'
import p2 from '../../assets/images/properties/p2.png'

function RecentPurchases() {
  let data = [
    {
      img: p1, // Add an image URL if available
      price: "$650 k",
      location: "16 km",
      area: "895 Sqm",
      rooms: "3", 
      restrooms: "1",
      cars_space: "2",
      development_potential: "Court with neighbouring lots rezoned for 4-unit development",
      amenities: "Close to freeway, shopping center, and train station"
    },
    { 
      img: p2, // Add an image URL if available
      price: "$450 k",
      location: "30 km",
      area: "600 Sqm",
      rooms: "3",
      restrooms: "1",
      cars_space: "2",
      development_potential: "Retain and build with 4-meter side access in a prime growth zone",
      amenities: "Close to freeway, shopping center and train station"
    },
  ];

  return (
    <div id="recent_purchases">
      <SectionName name="Recent Purchases" />
      {data.map((item, index) => (
        <div className="recent_purchases" data-aos="flip-down">
          {item.img && <img className="img" src={item.img} alt="Property" />}
          <div className="purchases">
            <div className="detail1">
              {item.price && (
                <div className="purchase_price">
                  <h5>Purchase Price</h5>
                  <div className="field">
                    <b>{item.price}</b>
                    <span>Auction</span>
                  </div>
                </div> 
              )}
              {item.location && (
                  <div className="Location">
                    <h5>Location</h5>
                    <div className="field">
                      <b>{item.location}</b>
                      <span>From Melbourne CBD</span>
                    </div>
                  </div>
                )}
            </div>
            <h5>Property Details</h5>
            <div className="specs_bar">
              <div className="field2">
                <b>{item.area}</b>
                <img src={icon1} alt="Area" />
              </div>
              <div className="field2">
                <b>{item.rooms}</b>
                <img src={icon2} alt="Rooms" />
              </div>
              <div className="field2">
                <b>{item.restrooms}</b>
                <img src={icon3} alt="Restrooms" />
              </div>
              <div className="field2">
                <b>{item.cars_space}</b>
                <img src={icon4} alt="Car Space" />
              </div>
            </div>
            {item.development_potential && (
              <div>
                <h5>Development Potential</h5>
                <p>{item.development_potential}</p>
              </div>
            )}
            {item.amenities && (
              <div>
                <h5>Amenities</h5>
                <p>{item.amenities}</p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default RecentPurchases;
